import { Outlet } from 'react-router-dom';

/**
 * Layout component - Minimal wrapper for MVP
 *
 * For the simplified MVP, we don't need a global header/footer.
 * - Login page has its own layout
 * - Whiteboard page has its own header with settings and logout
 * - Teacher code page has its own navigation
 */
export function Layout() {
  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex flex-col">
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}

/* =============================================================================
   ORIGINAL LAYOUT CODE - HIDDEN FOR MVP

export function OriginalLayout() {
  const isAuthenticated = useAppStore((state) => state.isAuthenticated);
  const user = useAppStore((state) => state.user);
  const logout = useAppStore((state) => state.logout);

  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex flex-col">
      <header className="bg-white dark:bg-neutral-800 shadow-sm border-b border-neutral-200 dark:border-neutral-700">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link
            to="/"
            className="text-xl font-bold text-neutral-900 dark:text-neutral-50"
          >
            Whiteboard Wizard
          </Link>

          <div className="flex items-center gap-4">
            {isAuthenticated ? (
              <>
                <Link
                  to="/dashboard"
                  className="text-neutral-600 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-neutral-50 transition-colors"
                >
                  Dashboard
                </Link>
                <span className="text-neutral-500 dark:text-neutral-400 text-sm">
                  {user?.name}
                </span>
                <button
                  onClick={logout}
                  className="text-neutral-600 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-neutral-50 transition-colors"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-neutral-600 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-neutral-50 transition-colors"
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="bg-consonant-500 text-white px-4 py-2 rounded-lg hover:bg-consonant-600 transition-colors"
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </nav>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-700 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-neutral-500 dark:text-neutral-400 text-sm">
          © 2026 Whiteboard Wizard. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

============================================================================= */

export default Layout;
